import RandingStyle9 from "../../randing/RandingStyle9";

function Randing205({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/205/01.png`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/orange/ApplyBenefitButton2.png`}
      adTarget="맘카페 이용자"
      // privacyMessage="개인정보수집에 동의하시는 분만 '상담문의' 버튼을 눌러주세요."
      eventDates={true}
      companyName="세계로탑치과의원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/segyeroTop.png`}
    />
  );
}

export default Randing205;
